import React from 'react';
import FeatureCard from './FeatureCard';

const features = [
  {
    title: 'Quick Recipes',
    description:
      'Find quick and easy recipes to cook within minutes based on the ingredients you have at home.',
    icon: '🍳'
  },
  {
    title: 'Meal Inspiration',
    description: 'Get healthy meal suggestions that taste great.',
    icon: '🥗'
  },
  {
    title: 'Cultural Cuisines',
    description: 'Explore meals from different cultures and regions.',
    icon: '🌍'
  }
];

const FeaturesSection = () => {
  return (
    <div className="container mx-auto px-4 py-16">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        {features.map((feature, index) => (
          <FeatureCard key={index} feature={feature} />
        ))}
      </div>
    </div>
  );
};

export default FeaturesSection;
